import React from 'react';
import stile from './stile.module.css';

function IconaMenu(props) {
    const classeEsterna = props.home
        ? stile.spazioIconaMenuEsternoHome
        : stile.spazioIconaMenuEsterno;

    return (
        <div
            className={classeEsterna}
            onClick={props.callback}
        >
            <img
                className={stile.iconaMenuHome}
                src={props.immagine}
                alt={props.testo}
            />

            <div className={props.evidenzia ? stile.testoIconaMenuHome2 : stile.testoIconaMenuHome}>
                {props.testo}
            </div>
        </div>
    );
}

export default IconaMenu;